import styled from 'styled-components';

export const EditContactsPage = styled.div`
  .row {
    margin-top: 50px;
  }

  .create-new, .edit-partner-name {
    display: inline-block;
    width: 220px;
    margin: 0 20px 30px 20px;
  }
  
  h2 {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .cards, .info {
    border: 1px solid #D8D2FF;
    padding: 20px;
  }

  .cards-wrapper, .info-card-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 14px;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
  }

  .info-card-wrapper .div {
    cursor: default !important;
  }
  
  .contact-line {
    margin: 20px 0;
    border-left: 1px solid #D8D2FF;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .value {
      color: var(--bllink-purple);
    }
    
    .actions {
      display: flex;
      
      div {
        margin: 0 5px;
      }
      
      img {
        cursor: pointer;
      }
    }
    
    
  }
`
